module.exports = __webpack_public_path__ + "img/roulette.b3df8b23.svg";